import React from "react";
import { useTranslation } from "react-i18next";
import SearchEmpty from "../../../../../app/src/Resources/Images/empty.png";

// Reutiliza la ilustración existente de Search.js (contrato §5, notas 18: "se reutiliza la
// ilustración actual"). variant="error" cubre los 500/fallos de red del contrato §2.4
// ("mensaje genérico y reintento manual"); el resto (400, sin resultados) usa la variante normal.
// Título/texto del estado vacío reutilizan search.find/search.find2 (idénticos, ya traducidos
// en toda la app); "Reintentar" reutiliza epg.error.retry por el mismo motivo.
const EmptyState = ({ variant = "empty", onClear, onRetry }) => {
  const { t } = useTranslation();
  const isError = variant === "error";

  return (
    <div className="bq-empty">
      <img src={SearchEmpty} alt="" className="bq-empty-image" />
      <div className="bq-empty-title">{isError ? t("search.buscar.errorTitle") : t("search.find")}</div>
      <div className="bq-empty-text">{isError ? t("search.buscar.errorText") : t("search.find2")}</div>
      <button type="button" className="bq-empty-button" onClick={isError ? onRetry : onClear}>
        {isError ? t("epg.error.retry") : t("search.buscar.emptyClear")}
      </button>
    </div>
  );
};

export default EmptyState;
